import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { PrimaryStore, SecondaryStore } from 'src/common/interfaces';
import { getMstSecondarySales } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const ModalGuideSecondaryStore = ({
  setIsOpen,
  onCallbackFunction,
  primaryStore,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onCallbackFunction: (item: SecondaryStore) => void;
  primaryStore: PrimaryStore;
}) => {
  const header = ['二次店コード', '二次店名'];
  const [secondaryStore, setSecondaryStore] = useState<Array<SecondaryStore>>([]);
  const [primaryStoreCd, setPrimaryStoreCd] = useState<string>(primaryStore?.mps_primary_cd?.toString() || '');
  const [secondaryStoreCd, setSecondaryStoreCd] = useState<string>('');
  const [secondaryStoreMn, setSecondaryStoreMn] = useState<string>('');

  const [searchSecondaryStore, { data: secondaryStoreData, loading: isSecondaryStoreLoading }] = useAppLazyQuery({
    query: gql(getMstSecondarySales),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onClickItemSecondaryStoreStore = (secondaryStore: SecondaryStore) => {
    onCallbackFunction(secondaryStore);
    setIsOpen(false);
  };

  const renderTableData = useMemo(() => {
    if (secondaryStore?.length <= 0 || !secondaryStore) return;
    return secondaryStore.map((secondaryStore: SecondaryStore, index: number) => {
      return (
        <tr key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{secondaryStore?.mss_secondary_cd}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p onClick={() => onClickItemSecondaryStoreStore(secondaryStore)}>{secondaryStore?.mss_secondary_nm}</p>
          </td>
        </tr>
      );
    });
  }, [secondaryStore]);

  const onPressSearch = () => {
    const params = {
      mss_primary_cd: primaryStoreCd === '' ? null : primaryStoreCd,
      mss_secondary_cd: secondaryStoreCd === '' ? null : secondaryStoreCd,
      mss_secondary_nm: secondaryStoreMn,
    };
    searchSecondaryStore({ variables: { input: params } });
  };

  useEffect(() => {
    const newMstSecondaryStoreData = { ...secondaryStoreData };
    const listSecondaryStore: SecondaryStore[] =
      newMstSecondaryStoreData?.getMstSecondarySales?.sort((store1: any, store2: any) => {
        return store1.mss_secondary_cd - store2.mss_secondary_cd;
      }) || [];
    setSecondaryStore(listSecondaryStore);
  }, [secondaryStoreData]);

  return (
    <div className="fixed w-full h-full inset-0 flex items-center justify-center">
      <div className="fixed w-full h-full inset-0 flex items-center justify-center">
        <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
        <div className="flex fixed bg-white h-4/6 w-1/3 items-center flex-col z-[1] overflow-auto">
          <div className="w-5/6 flex justify-end items-center mt-[10px]">
            <button onClick={() => setIsOpen(false)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[50px]">
            <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">一次店コード</div>
            <div className="h-full w-3/5 flex justify-center items-center">
              <input
                className="bg-transparent pl-[5px] h-[40px] w-full pr-[5px] "
                onChange={(event) => {
                  if (event.target.value.length > 8) return;
                  setPrimaryStoreCd(event?.target?.value);
                }}
                type="number"
                name="mss_primary_cd"
                value={primaryStoreCd}
                min={0}
                disabled
              />
            </div>
          </div>
          <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
            <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">二次店コード</div>
            <div className="h-full w-3/5 flex justify-center items-center">
              <input
                className="bg-transparent pl-[5px] h-[40px] w-full pr-[5px] "
                onChange={(event) => {
                  if (event.target.value.length > 8) return;
                  setSecondaryStoreCd(event?.target?.value);
                }}
                type="number"
                name="mss_secondary_cd"
                value={secondaryStoreCd}
                min={0}
              />
            </div>
          </div>
          <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
            <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">二次店名</div>
            <div className="h-full w-3/5 flex justify-center items-center">
              <input
                className="bg-transparent pl-[5px] h-[40px] w-full"
                onChange={(event) => {
                  if (event.target.value.length > 100) return;
                  setSecondaryStoreMn(event?.target?.value);
                }}
                type="text"
                name="mss_secondary_nm"
                value={secondaryStoreMn}
              />
            </div>
          </div>
          <div className="h-[40px] w-4/5	flex justify-end items-center mt-[10px] ">
            <button
              onClick={onPressSearch}
              className="border border-zinc-300 h-[40px] w-[100px] justify-center items-center flex"
            >
              <p>検索</p>
            </button>
          </div>
          <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
            <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]  ">
              <thead>
                <tr>{renderTableHeader()}</tr>
              </thead>
              <tbody>
                {isSecondaryStoreLoading ? (
                  <tr>
                    <td
                      colSpan={header.length}
                      className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                    >
                      Loading...
                    </td>
                  </tr>
                ) : (
                  renderTableData
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalGuideSecondaryStore;
